// extracted by mini-css-extract-plugin
export var banner = "_1z-0";
export var icon = "_1z-1";
export var message = "_1z-2";